import { render, staticRenderFns } from "./create-tool-set.vue?vue&type=template&id=5160b7b4&scoped=true"
import script from "./create-tool-set.vue?vue&type=script&lang=js"
export * from "./create-tool-set.vue?vue&type=script&lang=js"
import style0 from "./create-tool-set.vue?vue&type=style&index=0&id=5160b7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160b7b4",
  null
  
)

export default component.exports